import styled from 'styled-components';

export const SelectWrapper = styled.div`
  width: 100%;
  margin-bottom: 25px;
`;
